import {Directive, Input, OnChanges, OnInit, SimpleChanges, Type, ViewContainerRef} from "@angular/core";
import {SelectItem} from '../select-item';
import {ValueItem} from '../value-item';

@Directive({
    selector: '[ValueItemContainer]'
})
export class ValueItemDirective implements OnInit, OnChanges {

    @Input() item: SelectItem;
    @Input() fieldWrapperConfig;
    private componentRef;

    constructor(public viewContainerRef: ViewContainerRef) {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.fieldWrapperConfig.currentValue) {
            if (this.fieldWrapperConfig?.config.sourceItemComponent) {
                this.loadComponent(this.viewContainerRef, this.fieldWrapperConfig?.config.sourceItemComponent);
            }
        }
    }

    ngOnInit(): void {

    }
    private loadComponent(containerRef, component: Type<ValueItem>): void {
        const viewContainerRef = containerRef;
        viewContainerRef?.clear();
        this.componentRef = viewContainerRef.createComponent(component);
        this.componentRef.instance.item = this.item;

    }
}
